import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { store } from '../../store';

import './video-component.scss';

type VideoComponentType = {
  video: any,
  headline?: any
} & typeof defaultProps;
const defaultProps = {
  headline: '',
};

const VideoComponent = (props: VideoComponentType) => {
  const { video, headline } = props;
  const history = useHistory();

  return (
    <div className="video-component">
      <h2>{headline}</h2>
      <video width="100%" height="100%" autoPlay loop muted playsInline>
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

VideoComponent.defaultProps = defaultProps;

export default VideoComponent;
